import { useMemo } from 'react';
import { useListAllUsersQuery } from '../users/api/usersApi';
import { useListAllBrokerGroupsQuery } from '../brokerGroups/api/brokerGroupsApi';
import { getFeatureFlagSearchOptions } from './searchOptions';

/**
 * Fuse options for searching feature flags, with the targeted users' names and emails and
 * the broker groups' names read from the cached full lists. Stable until a list changes.
 */
export const useFeatureFlagSearchOptions = () => {
	const { data: users } = useListAllUsersQuery();
	const { data: brokerGroups } = useListAllBrokerGroupsQuery();

	return useMemo(
		() =>
			getFeatureFlagSearchOptions({
				usersById: new Map((users ?? []).map((user) => [user.id, user])),
				brokerGroupNames: new Map(
					(brokerGroups ?? []).map((brokerGroup) => [brokerGroup.id, brokerGroup.name]),
				),
			}),
		[users, brokerGroups],
	);
};
